import { D, dec, fiscalDateTime } from '@makila/fiscal';
export function checkPromotion(p) {
    if (p.kind === 'buy_x_pay_y') {
        if (!Number.isInteger(p.buyQty) || !Number.isInteger(p.payQty) || p.buyQty < 2 || p.payQty < 1 || p.payQty >= p.buyQty) {
            throw new Error('Leve X pague Y: X e Y inteiros, com Y entre 1 e X − 1');
        }
        if (!p.productIds?.length)
            throw new Error('Leve X pague Y: escolha os artigos');
        if (p.collections?.length)
            throw new Error('Leve X pague Y é por artigo, não por colecção');
    }
    else {
        const pct = dec(p.percent ?? 0);
        if (pct.lessThanOrEqualTo(0) || pct.greaterThanOrEqualTo(100) || pct.decimalPlaces() > 2)
            throw new Error('Percentagem entre 0 e 100, até 2 casas');
    }
    if (p.startsOn && p.endsOn && p.endsOn < p.startsOn)
        throw new Error('A data de fim é anterior à de início');
    if ((p.timeFrom === null) !== (p.timeTo === null))
        throw new Error('Indique as duas horas, ou nenhuma');
    if (p.timeFrom && p.timeTo && p.timeTo <= p.timeFrom)
        throw new Error('A hora de fim tem de ser depois da de início');
    if (p.weekdays && (!p.weekdays.length || p.weekdays.some((d) => !Number.isInteger(d) || d < 0 || d > 6)))
        throw new Error('Dias da semana inválidos');
}
/** A promoção vale neste instante (hora de Maputo)? */
export function promotionActive(p, now) {
    if (!p.active)
        return false;
    const t = fiscalDateTime(now); // YYYY-MM-DDTHH:mm:ss em Maputo
    const day = t.slice(0, 10), hm = t.slice(11, 16);
    if (p.startsOn && day < p.startsOn)
        return false;
    if (p.endsOn && day > p.endsOn)
        return false;
    if (p.weekdays && !p.weekdays.includes(new Date(`${day}T12:00:00Z`).getUTCDay()))
        return false;
    if (p.timeFrom && p.timeTo && (hm < p.timeFrom || hm >= p.timeTo))
        return false;
    return true;
}
const covers = (p, l) => (!p.productIds && !p.categoryIds && !p.collections?.length) || (p.productIds?.includes(l.productId) ?? false) || (!!l.categoryId && (p.categoryIds?.includes(l.categoryId) ?? false))
    || (!!l.collection && (p.collections?.some((c) => c.toLocaleLowerCase('pt') === l.collection.toLocaleLowerCase('pt')) ?? false));
/** Aplica as promoções em vigor ao carrinho. Devolve as linhas a emitir (as ofertas em linhas à parte). */
export function applyPromotions(lines, promos, now) {
    const live = promos.filter((p) => promotionActive(p, now));
    if (!live.length)
        return lines;
    const out = [];
    for (const l of lines) {
        const manual = !dec(l.discountPct ?? 0).isZero();
        if (manual || l.originLine !== undefined || l.regulatedPrice) {
            out.push(l);
            continue;
        }
        const q = dec(l.quantity);
        const bx = !l.soldByWeight && q.isInteger()
            ? live.filter((p) => p.kind === 'buy_x_pay_y' && covers(p, l))
                .map((p) => ({ p, free: q.div(p.buyQty).floor().times(p.buyQty - p.payQty) }))
                .filter((x) => x.free.greaterThan(0))
                .sort((a, b) => b.free.comparedTo(a.free))[0]
            : undefined;
        if (bx) {
            const paid = q.minus(bx.free);
            if (paid.greaterThan(0))
                out.push({ ...l, quantity: paid.toString() });
            out.push({ ...l, quantity: bx.free.toString(), discountPct: '100', promotionId: bx.p.id, description: `${l.description} — oferta (${bx.p.name})` });
            continue;
        }
        const pct = live.filter((p) => p.kind === 'percent' && covers(p, l)).sort((a, b) => new D(b.percent).comparedTo(a.percent))[0];
        out.push(pct ? { ...l, discountPct: new D(pct.percent).toString(), promotionId: pct.id } : l);
    }
    return out;
}
/**
 * Confere as linhas em promoção de um documento (na nuvem): a promoção existe,
 * valia no dia, e a linha tem exactamente o desconto dela (percentagem), ou é
 * oferta (100%) sem passar das unidades que o "leve X pague Y" dá.
 */
export function checkPromotionLines(lines, promos, issueDate) {
    const problems = [];
    const qtyByProduct = new Map();
    for (const l of lines)
        if (l.productId)
            qtyByProduct.set(l.productId, (qtyByProduct.get(l.productId) ?? new D(0)).plus(l.quantity));
    const freeByPromoProduct = new Map();
    lines.forEach((l, i) => {
        if (!l.promotionId)
            return;
        const p = promos.get(l.promotionId);
        const n = `linha ${i + 1}`;
        if (!p) {
            problems.push(`${n}: promoção desconhecida`);
            return;
        }
        if ((p.startsOn && issueDate < p.startsOn) || (p.endsOn && issueDate > p.endsOn))
            problems.push(`${n}: promoção "${p.name}" fora das datas`);
        const d = dec(l.discountPct ?? 0);
        if (p.kind === 'percent') {
            if (!d.equals(p.percent))
                problems.push(`${n}: desconto diferente do da promoção "${p.name}"`);
        }
        else {
            if (!d.equals(100))
                problems.push(`${n}: oferta da promoção "${p.name}" sem 100% de desconto`);
            const k = `${p.id}:${l.productId}`;
            freeByPromoProduct.set(k, (freeByPromoProduct.get(k) ?? new D(0)).plus(l.quantity));
            const total = qtyByProduct.get(l.productId ?? '') ?? new D(0);
            if (freeByPromoProduct.get(k).greaterThan(total.div(p.buyQty).floor().times(p.buyQty - p.payQty)))
                problems.push(`${n}: mais ofertas do que a promoção "${p.name}" dá`);
        }
    });
    return problems;
}
//# sourceMappingURL=promotions.js.map